// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"268":"c2727eae","665":"8697b641"}[chunkId] + ".chunk.css";
};